import { Field, useFormikContext } from 'formik'
import { useEffect, useState } from 'react'
import Flatpickr from 'react-flatpickr'
import Select from 'react-select'
import InputMask from 'react-input-mask'

import 'flatpickr/dist/themes/airbnb.css'

import getCities from 'src/feature/become-merchant/services/getCities'
import getCountries from 'src/feature/become-merchant/services/getCountries'
import getRegions from 'src/feature/become-merchant/services/getRegionsByCity'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import moment from 'moment'
import { isValidMail, isValidString } from 'src/_metronic/helpers/FieldValidator'

interface ColumnType {
  title: string
  tooltip?: string
  dataIndex: string
  key: string
  render?: (text: string, data: ColumnType) => JSX.Element
  status?: boolean
  yesOrNo?: boolean
  valueSelect?: boolean
  edit?: string
  maxLength?: number
  regex?: string
  formName?: string
  selects?: { value: any; text: string }[]
}

interface TableProps {
  loading?: boolean
  columns: ColumnType[][]
  dataSource: any
  editable?: boolean
  values?: any
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& string'in tamamını ifade eder.
}

export default function InlineTable({ loading, columns, dataSource, editable, values }: TableProps) {
  const { errors, touched, setTouched, setFieldValue } = useFormikContext()

  const [list, setList] = useState<{ countries: any[]; cities: any[]; regions: any[]; iso: [] }>({
    countries: [],
    cities: [],
    regions: [],
    iso: [],
  })

  useEffect(() => {
    if (!editable || !values) return

    getCountries().then((countries) => {
      if (!countries) return

      const country = countries.find((country) => country.id === values.countryID)

      getCities(country?.id || countries[0].id).then((cities) => {
        const city = cities.find((city) => city.id === values.cityID)

        getRegions(city?.id || cities[0].id).then((regions) => {
          setFieldValue('countryID', country?.id || countries[0].id || '')
          setFieldValue('cityID', city?.id || cities[0].id || '')

          if (regions[0] && regions[0].id) {
            setFieldValue('regionID', regions[0].id || '')
          }
          setList({ ...list, countries, cities, regions })
        })
      })
    })
  }, [editable])

  useEffect(() => {
    if (!editable || !values || !values.countryID) return

    getCities(values.countryID).then((cities) => {
      // setList({ ...list, cities: res });
      getRegions(cities[0].id).then((regions) => {
        setFieldValue('cityID', cities[0].id || '')

        if (regions[0] && regions[0].id) {
          setFieldValue('regionID', regions[0].id || '')
        }
        setList({ ...list, cities, regions })
      })
    })
  }, [values?.countryID])

  useEffect(() => {
    if (!editable || !values || !values.cityID) return

    getRegions(values.cityID).then((regions) => {
      if (regions[0] && regions[0].id) {
        setFieldValue('regionID', regions[0].id || '')
      }
      setList({ ...list, regions })
    })
  }, [values?.cityID])

  const statusCheck = (input: any) => {
    let text = 'Passive'
    let boolen = true

    switch (input) {
      case true:
        text = 'Active'
        boolen = true
        break
      case false:
        text = 'Passive'
        boolen = false
        break
      case 'Active':
        text = 'Active'
        boolen = true
        break
      case 'Passive':
        text = 'Passive'
        boolen = false
        break
      case '1':
        text = 'Active'
        boolen = true
        break
      case '0':
        text = 'Passive'
        boolen = false
        break
      case '2':
        text = 'Inactive'
        boolen = false
        break
      case '3':
        text = 'Passive'
        boolen = false
        break
      case 1:
        text = 'Active'
        boolen = true
        break
      case 2:
        text = 'Inactive'
        boolen = false
        break
      case 3:
        text = 'Passive'
        boolen = false
        break
      case 0:
        text = 'Passive'
        boolen = false
        break
      case 'Loyalty Enabled':
        text = 'Loyalty Enabled'
        boolen = true
        break
      case 'Loyalty Disabled':
        text = 'Loyalty Disabled'
        boolen = false
        break
    }

    return { boolen, text }
  }

  const yesOrNoCheck = (input: any) => {
    const activeTex = 'Yes'
    const passiveText = 'No'

    let text = passiveText
    let boolen = true

    switch (input) {
      case true:
        text = activeTex
        boolen = true
        break
      case false:
        text = passiveText
        boolen = false
        break
    }

    return { boolen, text }
  }

  const valueSelectsCheck = (input: any, selects: any) => {
    let boolen = true

    const selected = selects?.find((select) => select.value === input)
    boolen = selected.value === 1

    return {
      boolen,
      text: selected?.text || '',
    }
  }

  const formInput = (column: ColumnType) => {
    const name = column.formName || column.dataIndex

    switch (column.edit) {
      case 'input':
        return (
          <Field
            name={name}
            onChange={(e) => {
              let value =
                column.key === 'FirstName' || column.key === 'LastName'
                  ? isValidString(e.target.value)
                  : column.key === 'Email'
                    ? isValidMail(e.target.value)
                    : e.target.value
              setFieldValue(name, value)
            }}
            type='text'
            className='form-control w-50'
            // maxLength={51}
            {...(column.maxLength && { maxLength: column.maxLength })}
          />
        )
      case 'input_number':
        return (
          <Field
            name={name}
            type='text'
            className='form-control w-50'
            onKeyPress={(event) => {
              if (!/[0-9.-]/.test(event.key)) {
                event.preventDefault()
              }
            }}
          />
        )
      case 'input_regex':
        return (
          <Field
            name={name}
            type='text'
            className='form-control w-50'
            onKeyPress={(event) => {
              const regex = new RegExp(escapeRegExp(column.regex || ''))
              if (regex.test(event.key)) {
                event.preventDefault()
              }
            }}
          />
        )
      case 'select':
        let selectList = column.selects?.map((select) => ({
          value: select.value,
          label: select.text,
        }))
        let selectValue = selectList?.find((select) => select.value === dataSource[name])

        return (
          <Select
            className='custom-select inline-table-select'
            options={selectList}
            // value={selectValue}
            defaultValue={selectValue}
            components={{
              IndicatorSeparator: () => null
            }}
            onChange={(e) => setFieldValue(name, e?.value)}
          />
          // <>
          //   <select
          //     name={name}
          //     // type='select'
          //     // as='select'
          //     className='form-control form-select w-50'
          //     value={dataSource[name]}
          //     onChange={(e) => setFieldValue(name, e.target.value)}
          //   >
          //     {selectList?.map((select) => (
          //       <option key={select.value} value={select.value}>{select.label} {select.value}</option>
          //     ))}
          //   </select>
          // </>
        )
      case 'multiple_select':
        let selectMultiList = column.selects?.map((select) => ({
          value: select.value,
          label: select.text,
        }))
        let selectMultiValue = dataSource[name]?.map((value: any) =>
          selectMultiList?.find((select) => select.value === value)
        )

        return (
          <Select
            className='custom-select inline-table-select'
            options={selectMultiList}
            isMulti
            // value={selectValue}
            defaultValue={selectMultiValue}
            onChange={(e) => {
              setFieldValue(
                name,
                e?.map((item: any) => item.value)
              )
            }}
          />
        )
      case 'date':
        return (
          <Flatpickr
            className='form-control w-50'
            value={dataSource[column.dataIndex] === '0001-01-01T00:00:00.000Z' ? null : dataSource[column.dataIndex]}
            // {...(dataSource[column.dataIndex] === '0001-01-01T00:00:00.000Z' && {defaultDate: new Date()})}
            defaultDate={new Date()}
            onChange={(date) => setFieldValue(name, date[0])}
            options={{ dateFormat: 'm/d/Y' }}
          />
        )
      case 'time':
        return (
          <>
            <Flatpickr
              className='form-control w-50'
              value={dataSource[column.dataIndex]}
              placeholder='Select Time'
              // options={{ enableTime: true, noCalendar: true, dateFormat: "H:i" }}
              onChange={(date) => {
                const time = moment(date[0]).format('HH:mm')
                setFieldValue(name, time)
              }}
              options={{
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                dateFormat: 'H:i',
              }}
            />
          </>
        )
      case 'country':
        return (
          <Field component='select' name={name} className='form-control w-50'>
            {list.countries.map((country, index) => (
              <option key={index} value={country.id}>
                {country.name}
              </option>
            ))}
          </Field>
        )
      case 'city':
        return (
          <Field
            component='select'
            name={name}
            className='form-control w-50'
          // onChange={(e) => setForm && setForm({ ...form, [column.dataIndex]: e.target.value })}
          >
            {list.cities.map((city, index) => (
              <option key={index} value={city.id}>
                {city.name}
              </option>
            ))}
          </Field>
        )
      case 'region':
        return (
          <Field
            component='select'
            name={name}
            className='form-control w-50'
          // onChange={(e) => setForm && setForm({ ...form, [column.dataIndex]: e.target.value })}
          >
            {list.regions.map((region, index) => (
              <option key={index} value={region.id}>
                {region.name}
              </option>
            ))}
          </Field>
        )
      // case 'phone':
      //   console.log(dataSource[column.dataIndex])
      //   return (
      //     <div>
      //       <InputMask
      //         mask='+1 (999) 999-9999'
      //         name={name}
      //         className='form-control w-50'
      //         onChange={(e) => {
      //           console.log(e.target.value)
      //           setFieldValue(column.dataIndex, e.target.value)
      //         }}
      //       />
      //     </div>
      //   )
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255, 255, 255, 0.5)',
            zIndex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Loading...
        </div>
      )}
      <div className='row'>
        {columns.map((column, index) => {
          return (
            <div className={`col-md-${12 / columns.length}`} key={index}>
              {column.map((col, index) => {
                return (
                  <div className='row mb-7 align-items-center' key={index}>
                    <label className='col-lg-4 fw-semibold text-muted'>
                      {/* {col.title} */}
                      {col.title}
                      {col.tooltip && (
                        <span className='position-relative z-50'>
                          <OverlayTrigger
                            placement='top'
                            overlay={<Tooltip>{col.tooltip}</Tooltip>}
                          >
                            <i className='bi bi-info-circle text-primary ms-1'></i>
                          </OverlayTrigger>
                        </span>
                      )}
                    </label>

                    <div className='col-lg-8'>
                      {col.edit && editable ? (
                        <>
                          {col.edit === 'phone' ? (
                            <div>
                              <InputMask
                                mask='+1 (999) 999-9999'
                                name={col.formName || col.dataIndex}
                                className='form-control w-50'
                                value={values[col.formName || col.dataIndex]}
                                onChange={(e) => {
                                  setFieldValue(col.dataIndex, e.target.value)
                                }}
                                onClick={() => {
                                  setTouched({ ...touched, [col.dataIndex]: true })
                                }}
                                onBlur={() => {
                                  setTouched({ ...touched, [col.dataIndex]: true })
                                }}
                              />

                              {errors[col.dataIndex] && touched[col.dataIndex] && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>{errors[col.dataIndex]}</div>
                                </div>
                              )}
                            </div>
                          ) : (
                            <>
                              {formInput(col)}
                              {errors[col.dataIndex] && touched[col.dataIndex] && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>{errors[col.dataIndex]}</div>
                                </div>
                              )}
                            </>
                          )}

                        </>
                      ) : (
                        <span className='fw-bold fs-6 text-gray-800'>
                          {col.render ? (
                            col.render(dataSource[col.dataIndex], col)
                          ) : col.status ? (
                            <span
                              className={`badge badge-light-${statusCheck(dataSource[col.dataIndex]).boolen ? 'success' : 'danger'
                                } fw-bolder`}
                            >
                              {statusCheck(dataSource[col.dataIndex]).text}
                            </span>
                          ) : col.valueSelect ? (
                            <span
                              className={`badge badge-light-${valueSelectsCheck(dataSource[col.dataIndex], col?.selects || [])
                                .boolen
                                ? 'success'
                                : 'danger'
                                } fw-bolder`}
                            >
                              {
                                valueSelectsCheck(dataSource[col.dataIndex], col?.selects || [])
                                  .text
                              }
                            </span>
                          ) : col.yesOrNo ? (
                            <span
                              className={`badge badge-light-${yesOrNoCheck(dataSource[col.dataIndex]).boolen
                                ? 'success'
                                : 'danger'
                                } fw-bolder`}
                            >
                              {yesOrNoCheck(dataSource[col.dataIndex]).text}
                            </span>
                          ) : col.dataIndex && dataSource[col.dataIndex] ? (
                            dataSource[col.dataIndex]
                          ) : (
                            ''
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}
